import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Item,
  Money,
  EquipmentPack,
  BasicItem,
  Ammunition,
  MagicItemKeyword,
  PseudoItem,
  Spell,
  SpellLimitation,
  Campaign,
} from "@dndModels";
import { ALL_DRAGONS, CREATURE_TYPES } from "@dndModels/Constants";

// import DandDAPI from '../../utilities/system_api';
import DataUtilities from '@dndUtilities/data_utilities';
import { makeStyles } from "@utilities/theme_utilities";

import ItemDetails from "@dndComponents/equipment/ItemDetails";
import StringBox from "@components/input/strings/StringBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import ViewItem from "@dndComponents/display/ViewItem";
import SelectSpellBox from "@dndComponents/select/SelectSpellBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import CharacterManageInventoryItemMIK from "@dndComponents/character/inventory/manage/CharacterManageInventoryItemMIK";

interface Props {
  campaign: Campaign;
  log_it?: boolean;
  item: Item; 
  all_base_items: Item[];
  onSelect: (pseudo_item: PseudoItem, count: number) => void;
}

// const api = DandDAPI.getInstance();
const data_util = DataUtilities.getInstance();

export default function CampaignSelectItem({
  campaign,
  log_it,
  item,
  all_base_items,
  onSelect,
}: Props) {
  if (log_it) {
    debugger;
  }
  const use_pseudo_item = (item instanceof Item ? new PseudoItem(item) : new PseudoItem()); // item instanceof PseudoItem ? item.clone() : 
  let possible_miks: MagicItemKeyword[] = [];
  if (!(item instanceof EquipmentPack)) {
    console.log(data_util.magic_item_keywords);
    console.log(use_pseudo_item);
    const possible_mik_ids = use_pseudo_item.base_item?.possible_mik_ids??[];
    possible_miks = data_util.magic_item_keywords.filter(o => possible_mik_ids.includes(o._id));
  }
  const [use_count, setUseCount] = useState(use_pseudo_item.base_item instanceof BasicItem || use_pseudo_item.base_item instanceof Ammunition ? +use_pseudo_item.base_item.bundle_size : 1);
  const [expanded, setExpanded] = useState(false);
  const [pseudo_item, setPseudoItem] = useState(use_pseudo_item);
  const [extra_string, setExtraString] = useState("");
  const [extra_spell, setExtraSpell] = useState<Spell | null>(null);

  const useRowStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: "1px solid"
      },
    });
  });

  const renderMIKs = () => {
    if (pseudo_item.base_item instanceof Item) {
      return (
        <>
          { possible_miks.sort((a, b) => {
              if (a.min_rarity > b.min_rarity) {
                return 1;
              } else {
                if (a.min_rarity === b.min_rarity) {
                  return a.name.localeCompare(b.name);
                } else {
                  return -1;
                }
              }
            }).map(mik => {
            return (
              <Grid
                key={mik._id}
                size={{
                  xs: 12
                }}>
                <CharacterManageInventoryItemMIK 
                  pseudo_item={pseudo_item} 
                  mik={mik} 
                  onChange={(changed: PseudoItem) => {
                    setPseudoItem(changed);
                  }}
                />
              </Grid>
            );
          })}
        </>
      );
    }
  }
  
  const { classes, cx } = useRowStyles();
  
  let expanded_content: any = null;
  const cost_for_count = new Money();
  const bundle_cost = new Money();
  let bundle_size = 1;
  
  if (pseudo_item.magic_item_keywords.length === 0) {
    cost_for_count.copyGoldValue(item.cost * use_count);
    bundle_size = (item instanceof BasicItem || item instanceof Ammunition) ? +item.bundle_size : 1;
    bundle_cost.copyGoldValue(item.cost * bundle_size);
  }
  if (expanded) {
    expanded_content = (
      <Grid
        container
        spacing={0}
        direction="row"
        style={{ border: "1px solid", padding: "4px", backgroundColor: "black" }}
        size={{
          xs: 12
        }}>
        <Grid
          size={{
            xs: 12
          }}>
          <ItemDetails character={campaign} item={item instanceof PseudoItem && item.base_item instanceof Item ? pseudo_item : item} />
        </Grid>
        { pseudo_item.base_item instanceof Item && renderMIKs() }
        <Grid
          style={{ margin: "auto" }}
          size={{
            xs: 8
          }}>
          <StringBox 
            name="Count"
            value={`${use_count}`}
            type="number"
            onChange={(value: string) => {
              const new_count = Math.min(1, Math.floor(+value));
              if (!isNaN(new_count)) {
                setUseCount(new_count);
              }
            }}
          />
        </Grid>
        <Grid
          style={{ margin: "auto" }}
          size={{
            xs: 2
          }}>
          <ButtonBox
            name={`Add${ use_count > 1 ? ` (${use_count})` : ""}`}
            small
            onClick={() => {
              // debugger;
              onSelect(pseudo_item, use_count);
            }}
          />
        </Grid>
      </Grid>
    );
  }

  // if (item.name.includes("Abacus")) {
  //   console.log(item);
  // }
  if (item.extra_base_type === "Spell") {
    const extra_base_limits = item.extra_base_limits as { levels: string[], schools: string[], onSpellList: string[] };
    let spell_levels: number[] = [];
    if (extra_base_limits.levels.includes("Any")) {
      spell_levels = [0,1,2,3,4,5,6,7,8,9];
    } else {
      spell_levels = extra_base_limits.levels.map(o => {
        if (o === "Cantrip") {
          return 0;
        } else {
          return +o;
        }
      });
    }
    const spells = data_util.spells.filter(o => 
      spell_levels.includes(o.level) && 
      (extra_base_limits.schools.includes("Any") || 
        extra_base_limits.schools.includes(o.school))
    );
    const spell_limit = new SpellLimitation();
    spell_limit.spell_ids = spells.map(o => o._id);
    return (
      <>
        <Grid container spacing={0} direction="row"
          className={cx(classes.root, "padded")}>
          <Grid
            size={{
              xs: 4
            }}><ViewItem item={item} /></Grid>
          <Grid
            size={{
              xs: 6
            }}>
            <SelectSpellBox 
              name="Spell"
              value={extra_spell?._id??""}
              spell_limit={spell_limit}
              // specific_spell_ids={spells.map(o => o._id)}
              onChange={(changed: string) => {
                const spell = data_util.spells.find(o => o._id === changed);
                if (spell) {
                  setExtraSpell(spell);
                }
                setExtraString(changed);
              }}
            />
          </Grid>
          <Grid
            style={{ margin: "auto" }}
            size={{
              xs: 2
            }}>
            <ButtonBox
              name={`Add${ bundle_size > 1 ? ` (${bundle_size})` : ""}`}
              small
              disabled={ extra_string === "" || extra_spell === null }
              onClick={() => {
                // debugger;
                onSelect(pseudo_item, bundle_size);
              }}
            />
          </Grid>
          { expanded_content }
        </Grid>
      </>
    );
  } else if (item.extra_base_type !== "" && item.extra_base_type !== "None") {
    let extra_options: string[] = [];
    if (item.extra_base_type === "Dragon Breed") {
      const extra_base_limits = item.extra_base_limits as string[];
      extra_options = extra_base_limits.length > 0 ? extra_base_limits : ALL_DRAGONS;
    } else if (item.extra_base_type === "Creature Type") {
      const extra_base_limits = item.extra_base_limits as string[];
      extra_options = extra_base_limits.length > 0 ? extra_base_limits : CREATURE_TYPES;
    }
    return (
      <>
        <Grid container spacing={0} direction="row"
          className={cx(classes.root, "padded")}>
          <Grid
            className="clickable"
            onClick={() => { setExpanded(!expanded); }}
            size={{
              xs: 4
            }}>
            <ViewItem item={item} />
          </Grid>
          <Grid
            size={{
              xs: 6
            }}>
            <SelectStringBox
              name={item.extra_base_type}
              options={extra_options}
              value={extra_string}
              onChange={setExtraString}
            />
          </Grid>
          <Grid
            size={{
              xs: 2
            }}>
            <Grid container spacing={0} direction="row">
              <Grid
                style={{ margin: "auto" }}
                size={{
                  xs: 12
                }}>
                <ButtonBox
                  name={`Add${ bundle_size > 1 ? ` (${bundle_size})` : ""}`}
                  small
                  disabled={ extra_string === "" }
                  onClick={() => {
                    // debugger;
                    onSelect(pseudo_item, bundle_size);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          { expanded_content }
        </Grid>
      </>
    );
  } else {
    return (
      <>
        <Grid container spacing={0} direction="row"
          className={cx(classes.root, "padded")}>
          <Grid
            className="clickable"
            onClick={() => { setExpanded(!expanded); }}
            size={{
              xs: 10
            }}>
            <ViewItem item={item} />
          </Grid>
          <Grid
            size={{
              xs: 2
            }}>
            <Grid container spacing={0} direction="row">
              <Grid
                style={{ margin: "auto" }}
                size={{
                  xs: 12
                }}>
                <ButtonBox
                  name={`Add${ bundle_size > 1 ? ` (${bundle_size})` : ""}`}
                  small
                  onClick={() => {
                    // debugger;
                    onSelect(pseudo_item, bundle_size);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          { expanded_content }
        </Grid>
      </>
    );
  }
}
